// Détection du PRERENDU.
//
// `scripts/prerender.js` ouvre chaque page publique dans un Chrome sans tête
// après `npm run build`, attend que React ait fini, et enregistre le HTML
// obtenu dans build/<route>/index.html. Google reçoit donc une page pleine,
// pas une coquille `<div id="root">` à exécuter.
//
// Le script pose `window.__PRERENDER__ = true` AVANT le premier octet de
// notre code. Tout ce qui ne doit PAS tourner dans ce Chrome le lit ici :
//   - le pixel Meta et les balises Telegram (un robot n'est pas une visite) ;
//   - la révélation au défilement (sinon le HTML figé garde les sections
//     à opacité zéro, et c'est cela que Google lirait) ;
//   - la parallaxe (des `transform` inline sans intérêt dans un fichier).
export const PRERENDER =
  typeof window !== 'undefined' && window.__PRERENDER__ === true
